import { CALL_API } from '../middleware/api'

export const INCIDENCES_REQUEST = 'INCIDENCES_REQUEST'
export const INCIDENCES_SUCCESS = 'INCIDENCES_SUCCESS'
export const INCIDENCES_FAILURE = 'INCIDENCES_FAILURE'

export function fetchIncidences(Machine, Customer, Status, Category, StartDate, EndDate) {
  let params = ''

  if (Customer !== undefined) {
    params += `&Customer=${Customer}`
  }

  if (Machine !== undefined) {
    params += `&Machine=${Machine}`
  }

  if (Status !== undefined) {
    params += `&Status=${Status}`
  }

  if (Category !== undefined) {
    params += `&Category=${Category}`
  }

  if (StartDate !== undefined) {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined) {
    params += `&EndDate=${EndDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `incidences?${params}`,
      authenticated: true,
      types: [INCIDENCES_REQUEST, INCIDENCES_SUCCESS, INCIDENCES_FAILURE]
    }
  }
}

export const INCIDENCE_REQUEST = 'INCIDENCE_REQUEST'
export const INCIDENCE_SUCCESS = 'INCIDENCE_SUCCESS'
export const INCIDENCE_FAILURE = 'INCIDENCE_FAILURE'

export function fetchIncidence(number) {
  if (typeof number === 'string') {
    number = parseInt(number, 10)
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `incidences/${number}`,
      authenticated: true,
      types: [INCIDENCE_REQUEST, INCIDENCE_SUCCESS, INCIDENCE_FAILURE]
    }
  }
}

export const INCIDENCE_ADD_REQUEST = 'INCIDENCE_ADD_REQUEST'
export const INCIDENCE_ADD_SUCCESS = 'INCIDENCE_ADD_SUCCESS'
export const INCIDENCE_ADD_FAILURE = 'INCIDENCE_ADD_FAILURE'

export function addIncidence(incidence) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'incidences',
      authenticated: true,
      body: JSON.stringify(incidence),
      types: [INCIDENCE_ADD_REQUEST, INCIDENCE_ADD_SUCCESS,
              INCIDENCE_ADD_FAILURE]
    }
  }
}

export const INCIDENCE_UPDATE_REQUEST = 'INCIDENCE_UPDATE_REQUEST'
export const INCIDENCE_UPDATE_SUCCESS = 'INCIDENCE_UPDATE_SUCCESS'
export const INCIDENCE_UPDATE_FAILURE = 'INCIDENCE_UPDATE_FAILURE'

export function updateIncidence(number, props) {
  if (typeof number === 'string') {
    number = parseInt(number, 10)
  }

  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `incidences/${number}`,
      authenticated: true,
      body: JSON.stringify(props),
      types: [INCIDENCE_UPDATE_REQUEST, INCIDENCE_UPDATE_SUCCESS,
              INCIDENCE_UPDATE_FAILURE]
    }
  }
}

// Review incidence - OPEN -> IN_REVIEW
export const INCIDENCE_REVIEW_REQUEST = 'INCIDENCE_REVIEW_REQUEST'
export const INCIDENCE_REVIEW_SUCCESS = 'INCIDENCE_REVIEW_SUCCESS'
export const INCIDENCE_REVIEW_FAILURE = 'INCIDENCE_REVIEW_FAILURE'

export function reviewIncidence(number) {
  if (typeof number === 'string') {
    number = parseInt(number, 10)
  }

  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `incidences/review/${number}`,
      authenticated: true,
      types: [INCIDENCE_REVIEW_REQUEST, INCIDENCE_REVIEW_SUCCESS, INCIDENCE_REVIEW_FAILURE]
    }
  }
}

// Repair incidence - IN_REVIEW -> IN_REPAIR
export const INCIDENCE_REPAIR_REQUEST = 'INCIDENCE_REPAIR_REQUEST'
export const INCIDENCE_REPAIR_SUCCESS = 'INCIDENCE_REPAIR_SUCCESS'
export const INCIDENCE_REPAIR_FAILURE = 'INCIDENCE_REPAIR_FAILURE'

export function repairIncidence(number, repairActuation) {
  if (typeof number === 'string') {
    number = parseInt(number, 10)
  }

  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `incidences/repair/${number}`,
      authenticated: true,
      body: JSON.stringify({ RepairActuation: repairActuation }),
      types: [INCIDENCE_REPAIR_REQUEST, INCIDENCE_REPAIR_SUCCESS, INCIDENCE_REPAIR_FAILURE]
    }
  }
}

// Resolve incidence - IN_REVIEW or IN_REPAIR -> RESOLVED
export const INCIDENCE_RESOLVE_REQUEST = 'INCIDENCE_RESOLVE_REQUEST'
export const INCIDENCE_RESOLVE_SUCCESS = 'INCIDENCE_RESOLVE_SUCCESS'
export const INCIDENCE_RESOLVE_FAILURE = 'INCIDENCE_RESOLVE_FAILURE'

export function resolveIncidence(number, resolvedActuation) {
  if (typeof number === 'string') {
    number = parseInt(number, 10)
  }

  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `incidences/resolve/${number}`,
      authenticated: true,
      body: JSON.stringify({ ResolvedActuation: resolvedActuation }),
      types: [INCIDENCE_RESOLVE_REQUEST, INCIDENCE_RESOLVE_SUCCESS, INCIDENCE_RESOLVE_FAILURE]
    }
  }
}

export const INCIDENCE_RESET = 'INCIDENCE_RESET'

export function resetIncidence() {
  return { type: INCIDENCE_RESET }
}

export const DOWNLOAD_REQUEST = 'DOWNLOAD_REQUEST'
export const DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS'
export const DOWNLOAD_FAILURE = 'DOWNLOAD_FAILURE'

export function fetchIncidencesCSV(Status, Machine, StartDate, EndDate) {
  let params = ''

  if (Status !== undefined) {
    params += `&Status=${Status}`
  }
  
  if (Machine !== undefined) {
    params += `&Machine=${Machine}`
  }

  if (StartDate !== undefined) {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined) {
    params += `&EndDate=${EndDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `incidences/csv?${params}`,
      authenticated: true,
      types: [DOWNLOAD_REQUEST, DOWNLOAD_SUCCESS, DOWNLOAD_FAILURE]
    }
  }
}

export const INCIDENCES_OPEN_COUNT_REQUEST = 'INCIDENCES_OPEN_COUNT_REQUEST'
export const INCIDENCES_OPEN_COUNT_SUCCESS = 'INCIDENCES_OPEN_COUNT_SUCCESS'
export const INCIDENCES_OPEN_COUNT_FAILURE = 'INCIDENCES_OPEN_COUNT_FAILURE'

export function fetchOpenIncidencesCount() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'incidences/count/open',
      authenticated: true,
      types: [INCIDENCES_OPEN_COUNT_REQUEST, INCIDENCES_OPEN_COUNT_SUCCESS, INCIDENCES_OPEN_COUNT_FAILURE]
    }
  }
}
